import { uiRouterComponent } from '@mode/workspace-settings/feature-members-angularjs';
import { SignInComponent } from '../feature-sign-in/sign-in.component';
import { SignInOptionsComponent } from '../feature-sign-in-options/sign-in-options.component';
import { SignInService } from '../feature-sign-in/sign-in.service';
import { SignInOptionsService } from '../feature-sign-in-options/sign-in-options.service';

export const SignInRoutesConfig = [
  '$stateProvider',
  '$urlMatcherFactoryProvider',
  ($stateProvider, $urlMatcherFactoryProvider) => {
    $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider.state({
      name: 'sign-in',
      url: `/signin?auth_email`,
      ...uiRouterComponent(SignInComponent),
      resolve: {
        authEmailOrUserParam: [
          '$stateParams',
          'SignInService',
          function ($stateParams, sis: SignInService) {
            return sis.authEmailOrUserParam($stateParams);
          },
        ],
      },
    });

    $stateProvider.state({
      name: 'sign-in-options',
      url: `/signin/options?auth_email&redirect_to`,
      ...uiRouterComponent(SignInOptionsComponent),
      resolve: {
        signInOptionsApi: [
          '$stateParams',
          'SignInOptionsService',
          function ($stateParams, sios: SignInOptionsService) {
            return sios.getOptionsForOrganization($stateParams);
          },
        ],

        authEmail: [
          '$stateParams',
          function ($stateParams) {
            return $stateParams.auth_email ? $stateParams.auth_email : '';
          },
        ],
      },
    });

    $stateProvider.state({
      name: 'sign-in-account',
      url: `/signin?account_id`,
      ...uiRouterComponent(SignInOptionsComponent),
      resolve: {
        signInOptionsApi: [
          '$stateParams',
          'SignInService',
          function ($stateParams, sis: SignInService) {
            return sis.getSignInOptionsWithAccountId($stateParams.account_id);
          },
        ],
      },
    });
  },
];
